module.exports = __webpack_public_path__ + "img/Ident-Process-9-mobile.9412b5a0.png";